<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc">Contents</h1>
<p class="toc"><span epub:type="pagebreak" id="pageiii" title="iii"><a class="hlink" href="#/OEBPS/c01">The Summer of Discontent</a></span></p>
<p class="toc"><span class="hlink" href="#/OEBPS/bm1" title="Link target outside of Sample">Other Books by M.C. Beaton</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?bba7008e